class DawnInfiniteScroll {
  constructor() {
    this.containerSelector = '#ProductGridContainer';
    this.gridSelector = '#product-grid';
    this.paginationSelector = '.pagination-wrapper'; // Dawn pagination wrapper
    this.sentinelSelector = '#InfiniteScrollSentinel';

    this.isLoading = false;
    this.observer = null;
    this.domObserver = null;

    this.init();
  }

  init() {
    this.bindInfinite();
    this.watchForFilterRerenders();
  }

  // Get live elements (important because filters replace DOM)
  getEls() {
    const container = document.querySelector(this.containerSelector);
    const grid = document.querySelector(this.gridSelector);
    const pagination = document.querySelector(this.paginationSelector);
    const sentinel = document.querySelector(this.sentinelSelector);
    const nextLink = pagination ? pagination.querySelector('a[rel="next"], .pagination__item--next a, a') : null;
    console.log({container, grid, pagination, sentinel, nextLink})
    return { container, grid, pagination, sentinel, nextLink };
  }

  bindInfinite() {
    this.unbindInfinite();

    const { sentinel } = this.getEls();
    if (!sentinel) return;

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) this.loadNext();
    }, { root: null, threshold: 0.1 });

    this.observer.observe(sentinel);
  }

  unbindInfinite() {
    if (this.observer) this.observer.disconnect();
    this.observer = null;
  }

  async loadNext() {
    if (this.isLoading) return;

    const { grid, pagination, nextLink } = this.getEls();
    if (!grid || !pagination || !nextLink) return;

    const nextUrl = nextLink.href;
    if (!nextUrl) return;

    this.isLoading = true;
    pagination.classList.add('is-loading');

    try {
      const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector(this.gridSelector);
      const newPagination = doc.querySelector(this.paginationSelector);

      if (newGrid) {
        // Append only product items
        const newItems = Array.from(newGrid.children);
        newItems.forEach(item => grid.appendChild(item));
      }

      if (newPagination) {
        pagination.innerHTML = newPagination.innerHTML;
      } else {
        // No more pages
        pagination.remove();
        this.unbindInfinite();
      }

    } catch (e) {
      console.error('[InfiniteScroll] loadNext failed:', e);
    } finally {
      this.isLoading = false;
      const { pagination: pagNow } = this.getEls();
      if (pagNow) pagNow.classList.remove('is-loading');
    }
  }

  watchForFilterRerenders() {
    const root = document.querySelector('main') || document.body;

    // Filters in Dawn replace ProductGridContainer/grid/pagination.
    // MutationObserver lets us re-bind infinite scroll after that happens.
    this.domObserver = new MutationObserver(() => {
      // Rebind when DOM is swapped
      this.bindInfinite();
    });

    this.domObserver.observe(root, { childList: true, subtree: true });

    // Also handle back/forward
    window.addEventListener('popstate', () => this.bindInfinite());
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DawnInfiniteScroll();
});
